export {
    default as Image,
    IImageProps,
} from './image';
